import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Typography } from "@mui/material";
import React from "react";
import dayjs from "dayjs";
import { FaRegMap } from "react-icons/fa6";
import { RxCross2 } from "react-icons/rx";
import { useSelector } from "react-redux";
import { selectUser } from "../../../store/slice/user";
import IconCircle from "../../IconCircle";
import ModalWrapper from "../../ModalWrapper";
import { Style } from "./style";
import { useTranslation } from "react-i18next";

const TicketQR = ({ open, setOpen, data }) => {
  const { t } = useTranslation();
  const { language, email, mobile, name } = useSelector(selectUser);
  const isArabic = language === "ar";
  const event = data?.ticket?.event;
  const eventDate =
    event?.event_date && dayjs(event.event_date).isValid()
      ? dayjs(event.event_date).format("ddd, MMM D")
      : "";
  const eventTime =
    event?.event_time && dayjs(event.event_time, "HH:mm:ss").isValid()
      ? dayjs(event.event_time, "HH:mm:ss").format("h:mm A")
      : event?.event_time;

  return (
    <ModalWrapper open={open} crossIcon={false} sx={Style.main}>
      {/* Large Screen */}
      <Box sx={Style.firstChild}>
        <Box
          onClick={() => window.open(data?.ticket?.event?.map)}
          component={"div"}
        >
          <IconCircle icon={<FaRegMap style={Style.icon} />} />
        </Box>
        <Box onClick={() => setOpen(false)} component={"div"}>
          <IconCircle icon={<RxCross2 style={Style.icon} />} />
        </Box>
      </Box>
      {/* Large Screen */}
      {/* Small Screen */}
      <Typography
        sx={{
          display: "flex",
          textAlign: "start",
          justifyContent: "start",
          mt: { xs: "20px", sm: 0 },
          width: "100%",
          position: "relative",
        }}
      >
        <Typography
          component={"span"}
          onClick={() => setOpen(false)}
          sx={{
            position: "absolute",
            left: "10px",
            display: { xs: "flex", sm: "none" },
          }}
        >
          <ArrowBackIcon />
        </Typography>
        <Typography component={"span"} sx={Style.heading(isArabic)}>
          Ticket Details
        </Typography>
        <Typography
          onClick={() => window.open(data?.ticket?.event?.map)}
          component={"span"}
          sx={{
            position: "absolute",
            right: "10px",
            gap: "10px",
            display: { xs: "flex", sm: "none" },
            cursor: "pointer",
          }}
        >
          <FaRegMap style={Style.icon} />
        </Typography>
      </Typography>
      {/* Small Screen */}

      <Box sx={Style.ticketCard}>
        <Box sx={Style.ticketCardBody(isArabic)}>
          <Typography sx={Style.admitOneLabel(isArabic)}>
            {t("ticket_status_page.admit_one")}
          </Typography>
          <Typography sx={Style.ticketEventName(isArabic)}>
            {event?.translation?.[language]?.name}
          </Typography>
          <Typography sx={Style.ticketMetaLine(isArabic)}>
            {[eventDate, eventTime].filter(Boolean).join(" · ")}
          </Typography>
          <Typography sx={Style.ticketLocation(isArabic)}>
            {event?.translation?.[language]?.address}
          </Typography>
          <Typography sx={Style.ticketQty(isArabic)}>
            {data?.ticket?.is_free
              ? t("event_detail_page.free")
              : data?.ticket?.translation?.[language]?.name}
            {data?.qty ? ` × ${data.qty}` : ""}
          </Typography>
        </Box>
        <Box sx={Style.ticketStub}>
          <Box sx={Style.ticketNotch("top")} />
          {data?.qr_code?.full_qr_code ? (
            <Box
              component="img"
              src={data.qr_code.full_qr_code}
              alt="QR code"
              sx={Style.ticketQrImg}
            />
          ) : (
            <Typography sx={Style.ticketId}>No QR Found</Typography>
          )}
          <Box sx={Style.ticketNotch("bottom")} />
        </Box>
      </Box>

      <Typography sx={Style.orderNumber(isArabic)}>
        {t("ticket_status_page.order_number", { id: data?.id })}
      </Typography>

      <Box sx={Style.userDetailContainer(isArabic)}>
        <Typography>{name}</Typography>
        <Typography>{email}</Typography>
        <Typography>+{mobile}</Typography>
      </Box>

      {data?.seat_label && (
        <Box sx={Style.seatContainer(isArabic)}>
          <Typography sx={{ fontWeight: 600, fontSize: "13px", color: "rgba(255,255,255,0.65)" }}>
            {isArabic ? "رقم المقعد" : "Seat"}
          </Typography>
          <Typography sx={{ fontWeight: 700, fontSize: "16px", color: "#fff", letterSpacing: 1 }}>
            {data.seat_label}
          </Typography>
        </Box>
      )}

      <Typography sx={Style.organizationName(isArabic)}>
        Ticket By O7 Agency
      </Typography>
    </ModalWrapper>
  );
};

export default TicketQR;
